module.exports = __webpack_public_path__ + "static/media/game.44c3d9e6.jpg";